document.querySelectorAll('.header__inline-menu details').forEach((dropdown) => {
  let timeout;

  dropdown.addEventListener('mouseenter', () => {
    clearTimeout(timeout);
    dropdown.setAttribute('open', true);
  });

  dropdown.addEventListener('mouseleave', () => {
    timeout = setTimeout(() => {
      dropdown.removeAttribute('open');
    }, 50); // Adjust delay if needed
  });
});
